

<div style="display: inline;" >
    <button  mat-raised-button (click)="open()"   class="btncss"  [style.fontSize]="data.categoryFontSize" >{{menuData.categoryName | characterPipe}}
    </button>
</div>